var featuredSlider = document.querySelector(".index_ftr_slider");
if (featuredSlider) {
  const splide = new Splide(featuredSlider, {
    type: 'slide',
    perPage: 5,
    perMove: 1,
    gap: '2rem',
    autoplay: false,
    interval: 3000,  
    pagination: false,
    arrows: true, // explicitly state arrows
    breakpoints: {
      480: {
        perPage: 1.5,
        gap: '1rem'
      },
      768: {
        perPage: 1.5,
        gap: '1rem'
      },
      991: {
        perPage: 3,
        gap: '1rem'
      },
      1200: {
        perPage: 3,
        gap: '1rem'
      },
      1440: {
        perPage: 4,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (featuredSlider.querySelector('.splide__arrows')) {
      featuredSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}



(function () {
  const daysEl = document.getElementById("days");
  const hoursEl = document.getElementById("hours");
  const minutesEl = document.getElementById("minutes");
  const secondsEl = document.getElementById("seconds");

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  const RESET_DAYS = 3;
  const STORAGE_KEY = "limited_timer_end";

  function getEndTime() {
    const savedEnd = localStorage.getItem(STORAGE_KEY);

    if (savedEnd && new Date(savedEnd) > new Date()) {
      return new Date(savedEnd);
    }

    const newEnd = new Date();
    newEnd.setDate(newEnd.getDate() + RESET_DAYS);
    localStorage.setItem(STORAGE_KEY, newEnd);
    return newEnd;
  }

  const endTime = getEndTime();

  function updateTimer() {
    const now = new Date();
    let diff = endTime - now;

    if (diff <= 0) {
      localStorage.removeItem(STORAGE_KEY);
      location.reload();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    daysEl.textContent = String(days).padStart(2, "0");
    hoursEl.textContent = String(hours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  updateTimer();
  setInterval(updateTimer, 1000);
})();

/*Testimonial section */
document.addEventListener('DOMContentLoaded', function () {
  var reviewSlider = document.querySelector(".cltstmnl-slide");

  if (!reviewSlider) return;

  const splide = new Splide(reviewSlider, {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '2rem',
    autoplay: false,
    interval: 3000,
    pagination: false,
    arrows: true,
    breakpoints: {
      480: {
        perPage: 1.5,
        gap: '1rem'
      },
      768: {
        perPage: 1.5,
        gap: '1rem'
      },
      991: {
        perPage: 3,
        gap: '1rem'
      },
      1200: {
        perPage: 3,
        gap: '1rem'
      },
      1440: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });

  splide.on('mounted', () => {
    if (reviewSlider.querySelector('.splide__arrows')) {
      reviewSlider.classList.add('has-arrows');
    }
  });

  splide.mount();
});



document.addEventListener('DOMContentLoaded', function () {
    const rows = document.querySelectorAll('.deal-row');
    const btn = document.getElementById('loadMoreBtn');
    const spinner = btn.querySelector('.spinner');
    const btnText = btn.querySelector('.btn-text');

    let visible = 4;
    const step = 1;
    const splides = new Map();

    function mountSplide(row) {
      if (splides.has(row)) return;

      const splideEl = row.querySelector('.splide');
      const splide = new Splide(splideEl, {
        perPage: 4,
        perMove: 1,
        gap: '16px',
        pagination: false,
        arrows: true,
        breakpoints: {
          1280: { perPage: 3 },
          1024: { perPage: 3 },
          900: { perPage: 2.5 },
          768: { perPage: 1.5 },
        },
      });

      splide.mount();
      splides.set(row, splide);
    }

    function showRows() {
      rows.forEach((row, i) => {
        if (i < visible) {
          row.classList.remove('is-hidden');
          mountSplide(row);
        }
      });
    }

    // Initial
    showRows();
    if (rows.length <= visible) btn.style.display = 'none';

    btn.addEventListener('click', function () {
      spinner.style.display = 'inline-block';
      btnText.textContent = 'Loading...';

      setTimeout(() => {
        visible += step;
        showRows();
        spinner.style.display = 'none';
        btnText.textContent = 'Load More';

        if (visible >= rows.length) btn.style.display = 'none';
      }, 700);
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabId = btn.getAttribute("data-tab");

      // Remove active states
      buttons.forEach((b) => b.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      // Activate selected tab
      btn.classList.add("active");
      document.getElementById(tabId).classList.add("active");
    });
  });
});